import * as React from 'react';
import UpdateSecurityQuestionForm from 'components/UserManagement/UpdateSecurityQuestionForm';

export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class UpdateSecurityQuestionPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
      return <UpdateSecurityQuestionForm />;
  }
}
